module.exports = __webpack_public_path__ + "img/move-forward-icon.162201e8.svg";